import React, { useState, useRef, useEffect } from 'react';

import 'lazysizes';

// Components
import { Menu } from '../../../components/Vendas/Menu';
import { Logo } from '../../../components/Vendas/Menu/Logo';
import { BoxMenuMobile } from '../../../components/Vendas/Menu/BoxMenuMobile';
import { BoxMenu } from '../../../components/Vendas/Menu/BoxMenu';
import { Anchor } from '../../../components/Vendas/Menu/Anchor';
import { Button } from '../../../components/Vendas/Button';
import { Card } from '../../../components/Vendas/Card';
import { H2 } from '../../../components/Vendas/Card/H2';
import { H3 } from '../../../components/Vendas/Card/H3';
import { Message } from '../../../components/Vendas/Card/Message';
import { Price } from '../../../components/Vendas/Card/Price';
import { Paragraph } from '../../../components/Vendas/Card/Paragraph';
import { Image } from '../../../components/Vendas/Card/Image';
import { Modal } from '../../../components/Vendas/Modal';
import { Warranty } from '../../../components/Vendas/Waranty';
import { Faq } from '../../../components/Vendas/Faq';
import Loading from '../../../components/Loading';
import AddressAndPolicies from '../../../components/AddressAndPolicies';

// Services
import apiCursos from '../../../services/Cursos/api';

// Assets
import CursoLogo from '../../../assets/logo-papo-antimicrobianos.svg';
import MenuIcon from '../../../assets/menu-icon.png';
import CloseMenuIcon from '../../../assets/close-menu-icon.png';

// Styles
import {
  BoxHero,
  BoxPillars,
  BoxWaranty,
  BoxBuy,
  BoxFaq,
  BoxFooter,
} from './styles';

// Interface
interface Botao {
  title: string;
  url: string;
  target: string;
}
interface Pilar {
  icone_pilar: {
    title: string;
    url: string;
  };
  titulo_pilar: string;
  texto_pilar: string;
  conteudo: string;
  botao_pilar: Botao;
}

interface SubgrupoDuvidas {
  titulo_subgrupo: string;
  texto_subgrupo: string;
}

interface GrupoDuvidas {
  titulo_grupo: string;
  texto_grupo: string;
  subgrupo: [SubgrupoDuvidas];
}
interface Dados {
  vendas: {
    hero: {
      status_hero: boolean;
      imagem_hero: {
        title: string;
        url: string;
      };
      titulo_hero: string;
      texto_hero: string;
      botao_hero: Botao;
    };

    sobre: {
      status_sobre: boolean;
      titulo_sobre: string;
      pilares: [Pilar];
      botao_sobre: Botao;
    };

    garantia: {
      status_garantia: boolean;
      titulo_garantia: string;
      subtitulo_garantia: string;
      data_garantia: string;
      texto_garantia: string;
    };

    valores: {
      status_valores: boolean;
      promocional_valores: boolean;
      titulo_valores: string;
      subtitulo_valores: string;
      inclusos_valores: boolean;
      mensagem_valores: string;
      preco_anterior_valores: string;
      preco_valores: string;
      parcelas_valores: string;
      boleto_valores: string;
      botao_valores: Botao;
    };

    duvidas: {
      status_duvidas: boolean;
      titulo_duvidas: string;
      grupo_duvidas: [GrupoDuvidas];
    };
  };
}
const AntimicrobianoVendas: React.FC = () => {
  const [statusModal, setStatusModal] = useState<boolean>(false);
  const [modalContent, setModalContent] = useState('');
  const [menuMobile, setMenuMobile] = useState(false);
  const [dados, setDados] = useState<Dados | null>(null);
  const hostName = window.location.hostname;
  const url_traffic_source = window.location.search;

  useEffect(() => {
    apiCursos
      .get(`pages/${hostName === 'cursos.medway.com.br' ? `8` : `10163`}`)
      .then(response => {
        setDados(response.data.acf);
      });
  }, []);

  // Refs to Menu
  const scrollTo = (e: any) => window.scrollTo(0, e.current.offsetTop - 50);
  const boxHeroRef = useRef(null);
  const boxPillarsRef = useRef(null);
  const boxWarantyRef = useRef(null);
  const boxBuyRef = useRef(null);
  const boxFaqRef = useRef(null);

  return (
    <>
      {dados ? (
        <>
          <Menu>
            <Logo
              src={CursoLogo}
              alt="Papo de Antimicrobiano 3.0"
              width={140}
            />
            <BoxMenuMobile
              onClick={() => {
                setMenuMobile(!menuMobile);
              }}
              src={menuMobile ? CloseMenuIcon : MenuIcon}
            />
            <BoxMenu menuMobile={menuMobile}>
              <Anchor
                menuRef={boxHeroRef}
                setMenuMobile={setMenuMobile}
                type="button"
              >
                O Curso
              </Anchor>
              <Anchor
                menuRef={boxPillarsRef}
                setMenuMobile={setMenuMobile}
                type="button"
              >
                Metodologia
              </Anchor>
              <Anchor
                menuRef={boxWarantyRef}
                setMenuMobile={setMenuMobile}
                type="button"
              >
                Garantia
              </Anchor>
              <Anchor
                menuRef={boxFaqRef}
                setMenuMobile={setMenuMobile}
                type="button"
              >
                Dúvidas
              </Anchor>
              <Button
                fill="contained"
                size="small"
                pattern="base"
                onClick={() => {
                  scrollTo(boxBuyRef);
                  setMenuMobile(false);
                }}
              >
                Quero Comprar
              </Button>
            </BoxMenu>
          </Menu>

          {dados.vendas.hero.status_hero && (
            <BoxHero ref={boxHeroRef}>
              <section className="callToAction">
                <div className="boxContent">
                  <div
                    className="title"
                    dangerouslySetInnerHTML={{
                      __html: dados.vendas.hero.titulo_hero,
                    }}
                  />
                  <div
                    className="text"
                    dangerouslySetInnerHTML={{
                      __html: dados.vendas.hero.texto_hero,
                    }}
                  />
                  <Button
                    fill="contained"
                    size="small"
                    pattern="base"
                    className="buttonHero"
                    onClick={() => {
                      scrollTo(boxBuyRef);
                    }}
                  >
                    {dados.vendas.hero.botao_hero.title}
                  </Button>
                </div>
                <div className="boxImageHero">
                  <img
                    src={dados.vendas.hero.imagem_hero.url}
                    alt={dados.vendas.hero.imagem_hero.title}
                  />
                </div>
              </section>
            </BoxHero>
          )}

          {dados.vendas.sobre.status_sobre && (
            <BoxPillars ref={boxPillarsRef}>
              <div className="box-title">
                <h2 className="title">{dados.vendas.sobre.titulo_sobre}</h2>
              </div>
              <div className="box-content">
                {dados.vendas.sobre.pilares.map((item, key) => (
                  <Card align="center" key={key}>
                    <Image
                      className="lazyload"
                      src=""
                      data-srcset={`${item.icone_pilar.url} 1x`}
                      alt={item.icone_pilar.title}
                    />
                    <H3 align="center">{item.titulo_pilar}</H3>
                    <Paragraph align="center" weight={400}>
                      {item.texto_pilar}
                    </Paragraph>
                    <Button
                      onClick={() => {
                        setStatusModal(true);
                        setModalContent(item.conteudo);
                      }}
                      fill="outlined"
                      size="small"
                      pattern="base"
                    >
                      {item.botao_pilar.title}
                    </Button>
                  </Card>
                ))}
              </div>
              <div className="box-buttons">
                <Button
                  href={dados.vendas.sobre.botao_sobre.url}
                  target={dados.vendas.sobre.botao_sobre.target}
                  fill="outlined"
                  size="small"
                  pattern="variant"
                >
                  {dados.vendas.sobre.botao_sobre.title}
                </Button>
              </div>
            </BoxPillars>
          )}

          {dados.vendas.garantia.status_garantia && (
            <BoxWaranty ref={boxWarantyRef}>
              <Warranty
                title={dados.vendas.garantia.titulo_garantia}
                subtitle={dados.vendas.garantia.subtitulo_garantia}
                date={dados.vendas.garantia.data_garantia}
                text={dados.vendas.garantia.texto_garantia}
              />
            </BoxWaranty>
          )}

          {dados.vendas.valores.status_valores && (
            <BoxBuy ref={boxBuyRef} id="buy">
              <Card
                align="center"
                buy
                flag={dados.vendas.valores.promocional_valores}
              >
                <H2 align="center" buy>
                  {dados.vendas.valores.titulo_valores}
                </H2>
                <H3 align="center" buy>
                  {dados.vendas.valores.subtitulo_valores}
                </H3>
                {dados.vendas.valores.mensagem_valores && (
                  <Message
                    type="sucess"
                    dangerouslySetInnerHTML={{
                      __html: dados.vendas.valores.mensagem_valores,
                    }}
                  />
                )}
                <Price
                  type="old"
                  dangerouslySetInnerHTML={{
                    __html: dados.vendas.valores.preco_anterior_valores,
                  }}
                />
                <Price type="current">
                  {dados.vendas.valores.preco_valores}
                </Price>
                <Price type="percentage">
                  {dados.vendas.valores.boleto_valores}
                </Price>
                <Price type="instalments">
                  {dados.vendas.valores.parcelas_valores}
                </Price>
                <Button
                  href={`${dados.vendas.valores.botao_valores.url}${url_traffic_source}`}
                  fill="contained"
                  target={dados.vendas.valores.botao_valores.target}
                  size="big"
                  pattern="base"
                  fluid
                >
                  {dados.vendas.valores.botao_valores.title}
                </Button>
              </Card>
            </BoxBuy>
          )}

          {dados.vendas.duvidas.status_duvidas && (
            <BoxFaq ref={boxFaqRef}>
              <Faq
                title={dados.vendas.duvidas.titulo_duvidas}
                data={dados.vendas.duvidas.grupo_duvidas}
              />
            </BoxFaq>
          )}

          <BoxFooter>
            <div className="boxFooter">
              <p className="titleFooter">
                Ainda tem dúvidas? Entre em contato com a gente{' '}
                <a className="mailto" href="mailto:duvidas@medway.com.br">
                  duvidas@medway.com.br
                </a>
              </p>
            </div>
            <AddressAndPolicies background = '' />
          </BoxFooter>

          <Modal
            open={statusModal}
            setStatusModal={setStatusModal}
            modalContent={modalContent}
          />
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default AntimicrobianoVendas;
